<template>
  <div>
    <div class="d-flex align-items-center mb-6">
      <h1 class="mb-0 mr-auto">
        {{ isEdit ? $t('editCampaign') : $t('addCampaign') }}
      </h1>
      <button-back />
    </div>
    <b-row>
      <b-col cols="12" md="8" class="mb-3">
        <box>
          <div class="d-flex mb-2">
            <div>
              <h2 class="mb-0">{{ $t('campaignDetails') }}</h2>
            </div>
            <div v-if="campaign.status" class="ml-4">
              <span
                class="badge text-uppercase align-top"
                :class="`badge-${statusClass(campaign.status)}`"
              >
                {{ $t(`statuses.${campaign.status}`) }}
              </span>
            </div>
          </div>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <b-form-label
                  slot="label"
                  :label="'* ' + $t('campaignName')"
                  for="campaign-name"
                  :errors="errors.title"
                />
                <b-form-input
                  v-model="form.title"
                  :state="errors.title ? false : null"
                  id="campaign-name"
                  type="text"
                  size="lg"
                  :disabled="isDisabled"
                  required
                />
              </b-form-group>
            </b-col>
            <!-- <b-col sm="6" cols="12">
              <b-form-group>
                <slot name="label">
                  <label class="d-block col-form-label pt-0">
                    <file-upload
                      class="d-flex justify-content-between align-items"
                      post-action="/upload/post"
                      @input="updateFile"
                      extensions="gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp"
                      :multiple="false"
                      :disabled="isDisabled"
                      ref="upload"
                    >
                      <span class="float-left text-lighten">
                        {{ $t('thumbnail') }}:
                      </span>
                      <div class="float-right">
                        <svg-icon
                          icon="upload"
                          class="align-middle mr-1"
                          style="top: -1px;"
                        />
                        <span>{{ $t('uploadFiles') }}</span>
                      </div>
                    </file-upload>
                  </label>
                </slot>
                <b-form-input
                  id="thumbnail"
                  type="text"
                  size="lg"
                  v-model="form.filename"
                  :disabled="isDisabled"
                  required
                />
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col sm="6" cols="12">
              <b-form-group>
                <b-form-label
                  slot="label"
                  :label="'* ' + $t('startDate')"
                  for="campaign-start"
                  :errors="errors.start"
                />
                <v-date-picker
                  v-if="!isDisabled"
                  popover-visibility="focus"
                  :theme-styles="$config.datepicker.base"
                  :input-props="{
                    class: `form-control form-control-lg ${
                      errors.start ? 'is-invalid' : ''
                    }`,
                    id: 'campaign-start',
                    autocomplete: 'off'
                  }"
                  :formats="{ input: 'DD.MM.YYYY' }"
                  v-model="form.start"
                />
                <b-form-input
                  v-else
                  id="campaign-start"
                  type="text"
                  size="lg"
                  :value="form.start | formatDate"
                  :disabled="true"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="6" cols="12">
              <b-form-group>
                <b-form-label
                  slot="label"
                  :label="'* ' + $t('endDate')"
                  for="campaign-end"
                  :errors="errors.end"
                />
                <v-date-picker
                  v-if="!isDisabled"
                  popover-visibility="focus"
                  :theme-styles="$config.datepicker.base"
                  :input-props="{
                    class: `form-control form-control-lg ${
                      errors.end ? 'is-invalid' : ''
                    }`,
                    id: 'campaign-end',
                    autocomplete: 'off'
                  }"
                  :formats="{ input: 'DD.MM.YYYY' }"
                  v-model="form.end"
                />
                <b-form-input
                  v-else
                  id="campaign-end"
                  type="text"
                  size="lg"
                  :value="form.end | formatDate"
                  :disabled="true"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col sm="6" cols="12">
              <b-form-group>
                <b-form-label
                  slot="label"
                  :label="'* ' + $tc('category', 1)"
                  for="campaign-category"
                  :errors="errors.category"
                />
                <multi-select
                  :disabled="isDisabled"
                  :search="categories > 9"
                  :select-options="categories"
                  @input="val => (form.category = val[0] ? val[0] : null)"
                  :value="campaignCategory"
                  :btn-label="`${$tc('category', 1)}`"
                  size="lg"
                  id="campaign-category"
                  :is-invalid="typeof errors.category === 'string'"
                />
              </b-form-group>
            </b-col> -->
            <b-col lg="6" cols="12" v-if="$can('update-status', 'Campaign')">
              <b-form-group :label="`${$tc('status', 1)}:`">
                <b-form-label
                  slot="label"
                  :label="'* ' + $tc('status', 1)"
                  :errors="errors.status"
                />
                <multi-select
                  :btn-label="`${$tc('status', 1)}:`"
                  size="lg"
                  :select-options="statuses"
                  v-model="selectedCampaignStatus"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <br />
          <h2 class="title mb-3">{{ $t('companyInformation') }}</h2>
          <b-form>
            <b-row class="campaign-links">
              <b-col
                sm="6"
                cols="12"
                v-for="(link, index) in formLinks"
                :key="index"
              >
                <div role="group" class="form-group position-relative">
                  <button
                    class="edit-link border-0 p-0"
                    @click.prevent="editTitle(link)"
                    v-if="link.removable && link.title"
                  >
                    <svg-icon icon="pencil" class="text-muted icon-xs" />
                  </button>
                  <button
                    class="remove-link border-0 p-0"
                    @click.prevent="removeLink(link)"
                    v-if="link.removable"
                  >
                    <svg-icon icon="cross" class="text-danger icon-xs" />
                  </button>
                  <label
                    :for="getLinkLabel(link.title)"
                    class="d-block"
                    v-if="!link.editTitle"
                  >
                    {{ link.title }}:
                  </label>
                  <b-form-input
                    v-if="link.editTitle"
                    :value="link.title"
                    type="text"
                    class="link-title-input"
                    required
                    autofocus
                    :placeholder="$t('enterLinkTitle')"
                    @keydown.enter="setCustomLinkTitle($event, link)"
                    @blur="setCustomLinkTitle($event, link)"
                  />
                  <input-has-icon>
                    <svg-icon
                      v-if="link.icon && link.icon.name"
                      :icon="link.icon.name"
                      class="ml-1"
                      :class="link.icon.color"
                    />
                    <svg-icon v-else icon="link" class="ml-1 text-lighten" />
                    <b-form-input
                      v-model="link.uri"
                      size="lg"
                      :id="getLinkLabel(link.title)"
                      type="text"
                      required
                    />
                  </input-has-icon>
                </div>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end">
              <button
                @click.prevent="addLink()"
                class="btn btn-sm btn-link text-decoration-none"
              >
                <svg-icon icon="plus-round" class="icon-lg mr-1 align-middle" />
                <span class="align-middle font-weight-bold">
                  {{ $t('addLink') | upperCase }}
                </span>
              </button>
            </div>
          </b-form>
          <br />
          <br />
          <h2 class="mb-6">
            {{ $t('campaignDesc') }}
            <span v-if="errors.description" class="error text-danger">
              - {{ errors.description }}
            </span>
          </h2>
          <vue-editor
            class="ct-editor mb-6"
            v-model="form.description"
            :editor-toolbar="customToolbar"
          />
          <div class="text-right">
            <button
              id="submit-campaign"
              @click="submit()"
              class="btn btn-primary btn-lg pl-8 pr-8"
            >
              {{ $t('save') }}
            </button>
          </div>
        </box>
      </b-col>
      <b-col cols="12" md="4">
        <box>
          <!-- <b-form-checkbox
            v-if="isCreate"
            v-model="isIco"
            id="is-ico"
            class="mb-3"
          >
            {{ $t('isIco') }}
          </b-form-checkbox> -->
          <template v-if="isIco">
            <b-row>
              <b-col>
                <h2>{{ $t('tokenDetails') }}</h2>
              </b-col>
            </b-row>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('tokenStandart')"
                for="tokenStandard"
                :errors="errors.token"
                field="standard"
              />
              <multi-select
                id="tokenStandard"
                :disabled="isDisabled"
                @input="val => (form.token.standard = val[0] ? val[0] : null)"
                :value="tokenStandart"
                :is-invalid="!!(errors.token && errors.token.standard)"
                :search="tokenStandards > 9"
                :btn-label="$t('tokenStandart')"
                size="lg"
                :select-options="tokenStandards"
              />
            </b-form-group>
            <b-form-group :label="`${$t('name')}:`" label-for="token-name">
              <b-form-input
                v-model="form.token.name"
                :disabled="isDisabled"
                id="token-name"
                type="text"
                size="lg"
                required
              />
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('code')"
                for="code"
                :errors="errors.token"
                field="code"
              />
              <b-form-input
                :disabled="isDisabled"
                v-model="form.token.code"
                id="code"
                type="text"
                size="lg"
                :state="errors.token && errors.token.code ? false : null"
                required
              />
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('hardCap')"
                for="hard-cap"
                :errors="errors.token"
                field="hardCap"
              />
              <b-input-group prepend="$">
                <b-form-input
                  :disabled="isDisabled"
                  v-model="form.token.hardCap.amount"
                  id="hard-cap"
                  type="text"
                  size="lg"
                  :state="errors.token && errors.token.hardCap ? false : null"
                  required
                />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('softCap')"
                for="softCap"
                :errors="errors.token"
                field="softCap"
              />
              <b-input-group prepend="$">
                <b-form-input
                  :disabled="isDisabled"
                  v-model="form.token.softCap.amount"
                  id="softCap"
                  type="text"
                  size="lg"
                  :state="errors.token && errors.token.softCap ? false : null"
                  required
                />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('maxSupply')"
                for="maxSupply"
                :errors="errors.token"
                field="maxSupply"
              />
              <b-input-number
                :disabled="isDisabled"
                v-model.number="form.token.maxSupply"
                id="maxSupply"
                type="text"
                size="lg"
                :state="errors.token && errors.token.maxSupply ? false : null"
                required
              />
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="'* ' + $t('bountyBudget')"
                for="maxSupply"
                :errors="errors.budget"
              />
              <b-input-group prepend="%">
                <b-form-input
                  :disabled="isDisabled"
                  v-model="form.budget"
                  id="budget"
                  type="text"
                  size="lg"
                  :state="errors.budget ? false : null"
                  required
                />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-form-label
                slot="label"
                :label="$t('bountyBudget')"
                for="payment-guarantee"
                :errors="errors.guarantee"
              />
              <b-input-group prepend="$">
                <b-form-input
                  :disabled="isDisabled"
                  v-model="form.guarantee"
                  id="payment-guarantee"
                  type="text"
                  size="lg"
                  :state="errors.guarantee ? false : null"
                  required
                />
              </b-input-group>
            </b-form-group>
          </template>
          <b-form-group v-else>
            <b-form-label
              slot="label"
              :label="'* ' + $t('bountyBudget')"
              for="budget"
              :errors="errors.budget"
            />
            <b-input-group prepend="$">
              <b-form-input
                :disabled="isDisabled"
                v-model="form.budget.amount"
                id="budget"
                type="text"
                size="lg"
                :state="errors.budget ? false : null"
                required
              />
            </b-input-group>
          </b-form-group>
          <template v-if="isEdit">
            <task-manager
              id="campaign-task-manager"
              has-title
              small
              :tasks="form.tasks"
              :has-access-for-create="isEdit"
            />
          </template>
        </box>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack.vue';
import TaskManager from './components/CampaignAdd/TaskManager.vue';
import FileUpload from 'vue-upload-component';
import InputPassword from '@/components/Forms/InputPassword.vue';
import cloneDeep from 'clone';
import { mapActions } from 'vuex';
import { statusClassesMixin } from '@/utils/mixins.js';
import { toUTCDate, toUTCDateISOString, toEndDate } from '@/utils/date.js';

export default {
  head: {
    title() {
      const title = !this.isEdit
        ? this.$t('metaTitle.addBountyCampaign')
        : `${this.$t('metaTitle.editBountyCampaign')}`;
      const complexTitle =
        this.isEdit && this.campaign.title
          ? `${this.campaign.title} ${title}`
          : title;
      return {
        inner: complexTitle
      };
    }
  },

  mixins: [statusClassesMixin],

  components: {
    ButtonBack,
    TaskManager,
    FileUpload,
    InputPassword
  },

  data() {
    return {
      isIco: false,
      categories: [],
      tokenStandards: [],
      currencies: [],
      campaign: {},
      errors: {},
      statuses: [
        this.$config.statuses.get(0),
        this.$config.statuses.get(1),
        this.$config.statuses.get(2)
      ].map(el => {
        return {
          name: this.$filters.capitalize(this.$t(`statuses.${el}`)),
          value: el
        };
      }),
      selectedCampaignStatus: [],
      form: {
        manager: null,
        title: '',
        status: 'pending',
        category: null,
        filename: null,
        description: null,
        start: null,
        end: null,
        budget: {
          amount: null,
          currency: {}
        },
        guarantee: null,
        links: [
          {
            title: 'Website',
            uri: null,
            icon: {
              name: 'link',
              color: 'text-lighten'
            }
          },
          // {
          //   title: 'Whitepaper',
          //   uri: null,
          //   icon: {
          //     name: 'link',
          //     color: 'text-lighten'
          //   }
          // },
          {
            title: 'Twitter',
            uri: null,
            icon: {
              name: 'twitter',
              color: 'twitter-color'
            }
          },
          {
            title: 'Facebook',
            uri: null,
            icon: {
              name: 'facebook',
              color: 'facebook-color'
            }
          },
          {
            title: 'Telegram',
            uri: null,
            icon: {
              name: 'telegram',
              color: 'telegram-color'
            }
          },
          // {
          //   title: 'Bitcointalk',
          //   uri: null,
          //   icon: {
          //     name: 'bitcointalk',
          //     color: 'bitcointalk-color'
          //   }
          // },
          {
            title: 'Medium',
            uri: null,
            icon: {
              name: 'medium',
              color: 'medium-color'
            }
          },
          // {
          //   title: 'Reddit',
          //   uri: null,
          //   icon: {
          //     name: 'reddit',
          //     color: 'reddit-color'
          //   }
          // },
          {
            title: 'Youtube',
            uri: null,
            icon: {
              name: 'youtube',
              color: 'youtube-color'
            }
          },
          // {
          //   title: 'Bounty Telegram Link',
          //   uri: null,
          //   icon: {
          //     name: 'link',
          //     color: 'text-lighten'
          //   }
          // },
          // {
          //   title: 'Steemit',
          //   uri: null,
          //   icon: {
          //     name: 'steemit',
          //     color: 'steemit-color'
          //   }
          // },
          {
            title: 'Blog',
            uri: null,
            icon: {
              name: 'blog',
              color: 'text-secondary'
            }
          }
          // {
          //   title: 'Bitcointalk Bounty Link',
          //   uri: null,
          //   icon: {
          //     name: 'link',
          //     color: 'text-lighten'
          //   }
          // }
        ],
        token: null
      },
      editorSettings: this.$config.defaultEditorSettings.editorSettings,
      customToolbar: this.$config.defaultEditorSettings.customToolbar
    };
  },

  computed: {
    isCreate() {
      return this.$route.name === 'campaign-add';
    },
    isEdit() {
      return this.$route.name === 'campaign-edit';
    },
    campaignCategory() {
      if (!this.form.category) return [];
      return [
        this.categories.find(el => this.form.category.name === el.name)
      ].filter(el => el !== undefined);
    },
    tokenStandart() {
      if (!this.form.token || !this.form.token.standard) return [];
      return [
        this.tokenStandards.find(el => this.form.token.standard.id === el.id)
      ].filter(el => el !== undefined);
    },
    isDisabled() {
      return (
        this.isEdit &&
        !this.$ability.can('update', { ...this.form, __type: 'Campaign' })
      );
    },
    formLinks() {
      return this.form.links;
    }
  },

  methods: {
    ...mapActions({
      fetchCampaign: 'bounty/fetchCampaign',
      fetchCategories: 'bounty/fetchCategories',
      fetchTokenStandards: 'bounty/fetchTokenStandards',
      fetchCurrencies: 'bounty/fetchCurrencies'
    }),
    updateFile(val) {
      this.form.filename = val[0].name;
      this.$refs.upload.active = true;
    },
    addLink() {
      const newLink = {
        title: '',
        uri: null,
        icon: {
          name: 'link',
          color: 'text-lighten'
        },
        removable: true,
        editTitle: true
      };
      this.form.links.push(newLink);
    },
    removeLink(link) {
      let index = this.form.links.indexOf(link);
      if (index > -1) {
        this.form.links.splice(index, 1);
      }
    },
    editTitle(link) {
      link.editTitle = true;
    },
    getLinkLabel(title) {
      return (
        title &&
        title
          .split(' ')
          .join('-')
          .toLowerCase() + '-input'
      );
    },
    setCustomLinkTitle($event, link) {
      if ($event.target.value) {
        const currentLinkIndex = this.form.links.indexOf(link);
        const duplicate = this.form.links.find((item, index) => {
          return (
            item.title.toLowerCase() === $event.target.value.toLowerCase() &&
            currentLinkIndex !== index
          );
        });
        if (duplicate) {
          this.$notify('alert', {
            text: this.$t('linkTitleExists'),
            variant: 'danger',
            time: 5000
          });
          return;
        }
        link.title = $event.target.value;
        link.editTitle = false;
      }
    },
    getLinkByTitle(title) {
      let result = this.form.links.filter(link => link.title === title);
      return result[0];
    },
    createCampaign(campaign) {
      return this.$api.bounty.post('/v0/campaigns', campaign).then(
        res => {
          this.campaign = campaign;
          this.errors = {};
          this.$router.replace({
            name: 'campaign-edit',
            params: { id: res.data }
          });
          this.$notify('alert', {
            text: this.$t('campaignCreated'),
            variant: 'success',
            time: 5000
          });
        },
        e => {
          this.errors = {};

          if (e.response.data.errors) {
            this.errors = this.$parseErrors(e.response.data.errors) || {};
          } else {
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 0
              });
          }
        }
      );
    },
    updateCampaign(campaign) {
      return this.$api.bounty
        .put(`/v0/campaigns/${this.$route.params.id}`, campaign)
        .then(
          () => {
            this.campaign = campaign;
            this.errors = {};
            this.$notify('alert', {
              text: this.$t('campaignUpdated'),
              variant: 'success',
              time: 5000
            });
          },
          e => {
            this.errors = {};

            if (e.response.data.errors) {
              this.errors = this.$parseErrors(e.response.data.errors) || {};
            } else {
              e.response.data.detail &&
                this.$notify('alert', {
                  text: e.response.data.detail,
                  variant: 'danger',
                  time: 0
                });
            }
          }
        );
    },
    submit() {
      const USD = this.currencies.find(el => el.code === 'USD');
      const campaign = cloneDeep(this.form);

      if (campaign.start !== null) {
        campaign.start = toUTCDateISOString(campaign.start, true);
      }

      if (campaign.end !== null) {
        campaign.end = toUTCDateISOString(campaign.end, true);
      }

      if (this.isIco) {
        campaign.token.maxSupply = Number(campaign.token.maxSupply);
        campaign.token.softCap.currency = USD;
        campaign.token.hardCap.currency = USD;
      } else {
        campaign.budget.currency = USD;
      }

      campaign.links = this.form.links.filter(link => link.uri && link.title);

      if (this.isCreate) {
        campaign.manager = {
          id: this.$store.state.app.user.id
        };
        this.createCampaign(campaign).then(() => {
          this.form.status = 'pending';
        });
      }
      if (this.isEdit) this.updateCampaign(campaign);
    }
  },

  async created() {
    await this.fetchCategories().then(data => (this.categories = [...data]));
    await this.fetchTokenStandards().then(
      data => (this.tokenStandards = [...data])
    );
    await this.fetchCurrencies().then(data => (this.currencies = [...data]));

    this.form.category = this.categories[0];
    if (this.isEdit) {
      this.fetchCampaign({ id: this.$route.params.id }).then(res => {
        const form = cloneDeep(res);
        this.campaign = cloneDeep(res);
        const links = cloneDeep(form.links);
        form.links = this.form.links;

        links.forEach(el => {
          const link = this.getLinkByTitle(el.title);
          link !== undefined ? (link.uri = el.uri) : this.form.links.push(el);
        });

        form.start = toUTCDate(form.start);
        form.end = toUTCDate(form.end);

        this.selectedCampaignStatus = [
          {
            value: form.status,
            name: this.$filters.capitalize(this.$t(`statuses.${form.status}`))
          }
        ];
        if (form.token) this.isIco = true;
        if (form.token && !form.token.softCap) {
          form.token.softCap = {
            currency: {},
            amount: null
          };
        }
        form.category = this.categories[0];
        this.form = form;
      });
    }
  },

  watch: {
    'form.end': {
      handler() {
        this.form.end = toEndDate(this.form.end);
      }
    },
    campaign() {
      this.$emit('updateHead');
    },
    selectedCampaignStatus(val) {
      this.form.status = val[0] ? val[0].value : null;
    },
    isIco(val) {
      if (val && this.isCreate) {
        this.form.budget = null;
        this.form.token = {
          code: null,
          name: null,
          standard: null,
          maxSupply: null,
          softCap: {
            currency: {
              id: 'USD'
            },
            amount: null
          },
          hardCap: {
            currency: {
              id: 'USD'
            },
            amount: null
          },
          crowdsalesAt: null
        };
      } else if (!val && this.isCreate) {
        this.form.token = null;
        this.form.budget = {
          amount: null
        };
      }
    }
  }
};
</script>

<style lang="scss">
.campaign-links button {
  position: absolute;
  z-index: 1;
  top: 6px;
  line-height: 0;
  &:focus {
    outline: none;
  }
  &.remove-link {
    right: 0;
  }
  &.edit-link {
    right: 20px;
  }
}

.link-title-input {
  height: 26px;
  margin-bottom: 2px;
  border: none;
  padding: 0;
  font-size: 80%;
  font-weight: 600;

  &:focus {
    box-shadow: none;
  }
}
</style>
